import React from "react";
import Button from "../Button";
import Alert from "../Alert";

interface ItemDetailedViewFooterProps {
  alert: string;
  hasRevokeButton: boolean;
}

export default function ItemDetailedViewFooter(
  { alert, hasRevokeButton }: ItemDetailedViewFooterProps,
) {
  return (
    <footer className="d-flex gap-2
            align-items-start justify-content-end"
    >
      {alert && (
        <div className="flex-grow-1">
          <Alert alert={alert} />
        </div>
      )}
      <Button
        text="Audit Log"
        buttonStyle="btn-primary btn-lg"
        data-bs-toggle="modal"
        data-bs-target="#audit-log-modal"
      />
      {hasRevokeButton && (
        <Button
          text="Revoke Asset"
          buttonStyle="btn-primary btn-lg"
          data-bs-toggle="modal"
          data-bs-target="#revoke-modal"
        />
      )}
    </footer>
  );
}
